import { useQuery } from '@tanstack/react-query';
import { getPaymentClientSecret } from '@/services/payment';
import { GetPaymentClientSecretRequest } from '@/types/payment';
import { PAYMENT_CLIENT_SECRET_QUERY_KEY } from '@/constants/react_query_keys';

export function useGetPaymentClientSecret(data: GetPaymentClientSecretRequest) {
  return useQuery({
    queryKey: [PAYMENT_CLIENT_SECRET_QUERY_KEY],
    queryFn: () => getPaymentClientSecret(data),
    enabled: !!data.paymentId,
    retry: 2
  });
}
